import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { alertSuccess, alertError } from "Utils/alerts";
import PropTypes from "prop-types";
import { formatServerErrors } from "Utils/serverFormats";
import Toggle from "Components/toggle/Toggle";
import Slider from "Components/slider/Slider";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";

import { t } from "i18next";
import cx from "classnames";
import s from "./settingsArchive.scss";

const formInitialState = {
  retention: 3,
  default_archive: true,
};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isLoggedUserTrial: PropTypes.func,
};

class ArchiveDomainSettings extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    const { domain } = this.props;
    this.props.setInitialValues({
      default_retention: domain.default_retention,
      default_archive: domain.default_archive,
    });
  }

  submitForm(e) {
    e.preventDefault();
    let {
      refreshDomain,
      setFormLoading,
      unsetFormLoading,
      setFormErrors,
      formData,
      match: {
        params: { domainCode },
      },
    } = this.props;
    setFormLoading();
    const api = new QboxmailApi({ useCookie: true });
    api
      .editArchiveDomain(domainCode, formData)
      .then(() => {
        unsetFormLoading();
        refreshDomain(domainCode);

        this.props.setInitialValues({
          default_retention: formData.default_retention,
          default_archive: formData.default_archive,
        });

        alertSuccess(t("alert.domainUpdateSuccess"));
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          setFormErrors(errors);
          unsetFormLoading();
          alertError(t("alert.validationFailed"));
        });
      });
  }

  render() {
    const { formData, formErrors, setFormFieldValue, isFormLoading } = this.props;

    return (
      <form className={s.settingsArchive} method="post" onSubmit={this.submitForm}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine("default_retention", "default_archive") && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="archive_domain_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.archive.retention.title") + " Hello"}</div>
              <div className="sectionDesc">{t("settings.sections.archive.retention.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Slider
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.retention")}
                onChange={setFormFieldValue}
                name="default_retention"
                value={formData.default_retention}
                hint={<TranslatedString>input.hint.archive.retention</TranslatedString>}
                min={1}
                max={10}
                marks={{
                  1: 1,
                  2: 2,
                  3: 3,
                  4: 4,
                  5: 5,
                  6: 6,
                  7: 7,
                  8: 8,
                  9: 9,
                  10: 10,
                }}
              />
              <div />
            </div>
          </div>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.archive.newAccounts.title")}</div>
              <div className="sectionDesc">{t("settings.sections.archive.newAccounts.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.archiveOnNew")}
                name="default_archive"
                checked={formData.default_archive}
                errors={formErrors.default_archive}
                onChange={setFormFieldValue}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

ArchiveDomainSettings.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data.0", state),
  isDomainLoading: resActions.isResourceLoading("domain", state),
});

const mapDispatchToProps = (dispatch) => ({
  getDomain: (code) => dispatch(resActions.callApi("getDomain", "domain", code)),
  refreshDomain: (code) => dispatch(resActions.callApi("refreshDomain", "domain", code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(ArchiveDomainSettings, formInitialState));
